export function processConfigurableStockStatus(product) {
    let allVariantsOutOfStock = true;
    product.variants.forEach((variant) => {
        if (variant.product.stock_status !== 'OUT_OF_STOCK') {
            allVariantsOutOfStock = false;
        }
    });
    product.stock_status = allVariantsOutOfStock ? 'OUT_OF_STOCK' : product.stock_status;
}
